import { render, staticRenderFns } from "./OrganisationDetailsUsers.vue?vue&type=template&id=96ff185c&"
import script from "./OrganisationDetailsUsers.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetailsUsers.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetailsUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports